import { MainContentArea, ContentHeader, Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { UrlForwardList } from "../../components/urlforward/UrlForwardList";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

// Add Translation
export const UrlForward: React.FC = () => {
  const { t } = useTranslation();

  const [openAddNewForwardDrawer, setOpenAddNewForwardDrawer] = useState<boolean>(false);

  const setAddNewForwardDrawerFunction = (status: boolean) => {
    setOpenAddNewForwardDrawer(status)
  }

  const {roles} = useRolesContext();

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.tiny_url")}
          extra={roles.URL_FORWARDS_CREATE && <Button
            key="add-new-forward"
            type="primary"
            icon={<PlusIcon />}
            onClick={async () => {
              setAddNewForwardDrawerFunction(true);
            }}
          >
            {t("main_menu.add_new_forward")}
          </Button>}
        />
      }
    >
      <UrlForwardList openAddNewForwardDrawer={openAddNewForwardDrawer} setAddNewForwardDrawerFunction={setAddNewForwardDrawerFunction}></UrlForwardList>

    </MainContentArea>
  );
};
